import { useOidc } from '@axa-fr/react-oidc';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import LoadingComponent from '../loading/LoadingComponent';

const Callback = () => {
  const navigate = useNavigate();
  const { isAuthenticated, error } = useOidc();

  useEffect(() => {
    if (error) {
      // En cas d'erreur, rediriger vers la page d'erreur
      console.error('auth error');
      console.error({ error });
      sessionStorage.setItem('authError', JSON.stringify(error));
      navigate('/auth/error', { replace: true });
      return;
    }

    if (isAuthenticated) {
      console.log('isAuthenticated', isAuthenticated);
      // Récupérer le chemin de redirection stocké, sinon utiliser le dashboard
      const redirectPath =
        sessionStorage.getItem('redirectPath') || '/dashboard/products';
      sessionStorage.removeItem('redirectPath'); // Nettoyer après utilisation
      navigate(redirectPath, { replace: true });
    }
    console.log('isAuthenticated', isAuthenticated);
  }, [isAuthenticated, error, navigate]);

  return <LoadingComponent />;
};

export default Callback;
